/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ClearChargingProfileTask
 */
export interface ClearChargingProfileTask {
    /**
     *
     * @type {string}
     * @memberof ClearChargingProfileTask
     */
    profileId?: string;
    /**
     *
     * @type {number}
     * @memberof ClearChargingProfileTask
     */
    connectorIndex?: number;
    /**
     *
     * @type {string}
     * @memberof ClearChargingProfileTask
     */
    chargingProfilePurpose?: string;
    /**
     *
     * @type {string}
     * @memberof ClearChargingProfileTask
     */
    stackLevel?: string;
}

/**
 * Check if a given object implements the ClearChargingProfileTask interface.
 */
export function instanceOfClearChargingProfileTask(
    value: object,
): value is ClearChargingProfileTask {
    return true;
}

export function ClearChargingProfileTaskFromJSON(
    json: any,
): ClearChargingProfileTask {
    return ClearChargingProfileTaskFromJSONTyped(json, false);
}

export function ClearChargingProfileTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ClearChargingProfileTask {
    if (json == null) {
        return json;
    }
    return {
        profileId: json["profileId"] == null ? undefined : json["profileId"],
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        chargingProfilePurpose:
            json["chargingProfilePurpose"] == null
                ? undefined
                : json["chargingProfilePurpose"],
        stackLevel: json["stackLevel"] == null ? undefined : json["stackLevel"],
    };
}

export function ClearChargingProfileTaskToJSON(
    value?: ClearChargingProfileTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        profileId: value["profileId"],
        connectorIndex: value["connectorIndex"],
        chargingProfilePurpose: value["chargingProfilePurpose"],
        stackLevel: value["stackLevel"],
    };
}
